// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'select2';
import 'select2/dist/css/select2.css';

Rails.start()
Turbolinks.start()
ActiveStorage.start()

if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker.register("/service-worker.js").catch(function (error) {
      console.warn("Service worker registration failed:", error);
    });
  });
}

// js
import "css/site"
import "css/advertisement_campaigns"
import 'jquery'
import '@popperjs/core'
import * as bootstrap from 'bootstrap'
import "css/main_register"
import "./main_register"
import './message'
import './navigation'
import './diary'
import './event'
import './question'
import './community'
import "css/notification"
import "css/post"
import './post'
import "css/search"
import "css/navigation"
import "css/common"
import "css/additional_info"
import "css/footer"
import "css/registration"
import "css/rank"
import "css/hotel"
import "./jquery.star-rating.js"
import "css/owner_register"
import "./preview_owner"
import "css/hospital"
import "css/my_page"
import "css/crawl"
import "css/report"
// TODO: Remove old advertisement system - replaced by AdvertisementCampaign
// import "css/advertisement"
import "css/zenmarugothic"
import "./advertisement"
import "./validation-schema"
import "./validation-helper"
import "./inquiry"
import "./success_inquiry"
import "css/my_pet"
import "css/layout_my_page"
import "css/icon_transaction"
import "./icon_random"
import "./change_pet_display"
import './admin_message_preview'
import "css/hotels/hotel"
import "./hotel"
import "./subcategory"
import "./hospital"
import "./comment"
import "css/other_service"
import "./other_service";
import "./youtuber"
import "css/youtubers"
import "css/admin"
import "./community_background_image"
import "./youtubers_like"
import "./youtuber_form"
import "css/admin_styles"
import "./admin_qa"
import "css/admin_qa"
import "css/youtuber_form"
import "css/ambassador"
import "./admin_diary_edit"
import "./petter_ai_chat"
import "./native_push_registration"

window.bootstrap = bootstrap;

function resetMobileNavigationState() {
    var appBody = document.querySelector("#app_body");
    var animatedIcon = document.querySelector(".animated-icon");
    var mobileNavigation = document.querySelector(".navigation_mobile_item");

    if (appBody) {
        appBody.classList.remove("d-none");
    }

    if (animatedIcon) {
        animatedIcon.classList.remove("open");
    }

    if (mobileNavigation) {
        mobileNavigation.classList.add("d-none");
    }
}

document.addEventListener("turbolinks:before-cache", resetMobileNavigationState);

function shouldScrollTopAfterClick(link) {
    if (!link || !link.href) return false;
    if (link.target && link.target !== "_self") return false;
    if (link.hasAttribute("download")) return false;
    if (link.dataset.noScrollTop === "true") return false;

    var url;
    try {
        url = new URL(link.href, window.location.href);
    } catch (_error) {
        return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (["tel:", "mailto:", "javascript:"].includes(url.protocol)) return false;

    var samePath = url.pathname === window.location.pathname && url.search === window.location.search;
    if (samePath && url.hash) return false;

    return true;
}

function rememberScrollTopAfterVisit(event) {
    var link = event.target.closest && event.target.closest("a");
    if (!shouldScrollTopAfterClick(link)) return;

    sessionStorage.setItem("petterScrollTopAfterVisit", "1");
}

function scrollToTopAfterVisit() {
    if (sessionStorage.getItem("petterScrollTopAfterVisit") !== "1") return;

    sessionStorage.removeItem("petterScrollTopAfterVisit");
    requestAnimationFrame(function () {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    });
}

function isPetterNativeAppView() {
    var userAgent = navigator.userAgent || "";
    var hasExplicitPetterAppToken = /Petter|jp\.petter\.app/i.test(userAgent) ||
        new URLSearchParams(window.location.search).has("petter_app") ||
        new URLSearchParams(window.location.search).get("native_app") === "petter";
    var isIosWebView = /iPhone|iPad|iPod/.test(userAgent) &&
        userAgent.indexOf("AppleWebKit") !== -1 &&
        userAgent.indexOf("Safari") === -1;
    var isAndroidWebView = /; wv\)|\bwv\b|Version\/\d+(?:\.\d+)? Chrome/i.test(userAgent);

    return hasExplicitPetterAppToken || isIosWebView || isAndroidWebView;
}

function hideAppDownloadCtaInNativeApp() {
    if (!isPetterNativeAppView()) return;

    document.querySelectorAll("[data-hide-in-petter-app]").forEach(function (element) {
        element.classList.add("d-none");
        element.setAttribute("aria-hidden", "true");
    });
}

document.addEventListener("click", rememberScrollTopAfterVisit, true);
document.addEventListener("turbolinks:load", scrollToTopAfterVisit);
document.addEventListener("turbolinks:load", hideAppDownloadCtaInNativeApp);
window.addEventListener("pageshow", scrollToTopAfterVisit);
window.addEventListener("pageshow", hideAppDownloadCtaInNativeApp);

$(document).on('turbolinks:load', function () {

    // navigation
    resetMobileNavigationState();

    var buttonMenu = document.querySelector(".button-menu");
    if(buttonMenu && buttonMenu.dataset.initialized !== "true") {
        buttonMenu.dataset.initialized = "true";
        buttonMenu.addEventListener("click", function () {
            document.querySelector(".animated-icon").classList.toggle("open");
            document.querySelector("#app_body").classList.toggle("d-none");
            var mobileNavigation = document.querySelector(".navigation_mobile_item");
            if (mobileNavigation) {
              mobileNavigation.classList.toggle("d-none");
            }
        });
    }
    // end navigation

    $('.toggle-comment-form').on('click', function () {
        $(this).siblings('.comment-form').toggle();
    });

    $('.toggle-new-comment-form').on('click', function (event) {
        $(this).siblings('.new-comment-form').toggle();
    });

    checkPrefectureSelection();
    // Get the category and subcategory select elements
    var categorySelect = $('#category-select');
    var subcategorySelect = $('#subcategory-select');

    // Handle the change event of the category select
    categorySelect.on('change', function () {
        var categoryId = $(this).val();
        console.log(categoryId);

        // Make an AJAX request to fetch the subcategories for the selected category
        $.ajax({
            url: '/categories/' + categoryId + '/subcategories',
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                // Clear the existing subcategory options
                subcategorySelect.empty();
                // console.log(categoryId);

                // // Add the default prompt option
                // subcategorySelect.append('<option value="">中分類を選んでください</option>');

                // Append the fetched subcategories as options
                $.each(data, function (index, subcategory) {
                    subcategorySelect.append('<option value="' + subcategory.id + '">' + subcategory.name + '</option>');
                });
            },
            error: function () {
                console.log('Error fetching subcategories.');
            }
        });
    });


    // Get the category and subcategory select elements
    var categorySelect2 = $('#category-select2');
    var subcategorySelect2 = $('#subcategory-select2');

    // Handle the change event of the category select
    // var radioContainer = $('.btn-check');
    $(document).on('change', '.btn-category', function () {
        var categoryId = $(this).val()
        console.log(categoryId)

        // Make an AJAX request to fetch the subcategories for the selected category
        $.ajax({
            url: '/categories/' + categoryId + '/subcategories',
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                // Clear the existing subcategory options
                subcategorySelect2.empty();

                // Add the default prompt option
                //   subcategorySelect2.append('<option value="">Select Subcategory</option>');

                // Append the fetched subcategories as options
                $.each(data, function (index, subcategory) {
                    subcategorySelect2.append('<option value="' + subcategory.id + '">' + subcategory.name + '</option>');
                });
            },
            error: function () {
                console.log('Error fetching subcategories.');
            }
        });
    });

    // Get the category and subcategory select elements
    var categorySelect2 = $('#category-select4');
    var subcategorySelect2 = $('#subcategory-select4');

    // Handle the change event of the category select
    // var radioContainer = $('.btn-check');
    $(document).on('change', '.btn-category', function () {
        var categoryId = $(this).val()

        // Make an AJAX request to fetch the subcategories for the selected category
        $.ajax({
            url: '/categories/' + categoryId + '/subcategories',
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                // Clear the existing subcategory options
                subcategorySelect2.empty();

                // Add the default prompt option
                //   subcategorySelect2.append('<option value="">Select Subcategory</option>');

                // Append the fetched subcategories as options
                $.each(data, function (index, subcategory) {
                    subcategorySelect2.append('<option value="' + subcategory.id + '">' + subcategory.name + '</option>');
                });
            },
            error: function () {
                console.log('Error fetching subcategories.');
            }
        });
    });


    // Get the category and subcategory select elements
    var categorySelect3 = $('#category-select3');
    var subcategorySelect3 = $('#subcategory-select3');

    // Handle the change event of the category select
    categorySelect3.on('change', function () {
        var categoryId = $(this).val();

        // Make an AJAX request to fetch the subcategories for the selected category
        $.ajax({
            url: '/categories/' + categoryId + '/subcategories',
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                // Clear the existing subcategory options
                subcategorySelect3.empty();

                // Add the default prompt option
                //   subcategorySelect2.append('<option value="">Select Subcategory</option>');

                // Append the fetched subcategories as options
                $.each(data, function (index, subcategory) {
                    subcategorySelect3.append('<option value="' + subcategory.id + '">' + subcategory.name + '</option>');
                });
            },
            error: function () {
                console.log('Error fetching subcategories.');
            }
        });
    });

    $('#filterButton').click(function () {
        $('#filterBox').toggle();
    });


    $('#pet-prefecture-select').on('change', function () {
        var selectedRegion = $(this).val();
        var citySelect = $('#pet-city-select');
        console.log(citySelect);

        // Fetch the JSON data using AJAX
        $.ajax({
            url: '/prefectures_with_cities.json',
            method: 'GET',
            dataType: 'json',
            success: function (regionsWithCities) {
                var cities = regionsWithCities[selectedRegion] || [];

                // Clear existing city options and add the new ones based on the cities array
                citySelect.empty();
                citySelect.append($('<option>', {value: '', text: '市町村を選択'}));
                $.each(cities, function (index, city) {
                    citySelect.append($('<option>', {value: city, text: city}));
                });
            },
            error: function () {
                console.log('Error fetching regions with cities.');
            }
        });
    })

    $('.prefecture-select-box').on('change', function () {
        var selectedRegion = $(this).val();
        var citySelect = $('.city-select-box');

        // Fetch the JSON data using AJAX
        $.ajax({
            url: '/prefectures_with_cities.json',
            method: 'GET',
            dataType: 'json',
            success: function (regionsWithCities) {
                var cities = regionsWithCities[selectedRegion] || [];

                // Clear existing city options and add the new ones based on the cities array
                citySelect.empty();
                citySelect.append($('<option>', {value: '', text: '市町村を選択'}));
                $.each(cities, function (index, city) {
                    citySelect.append($('<option>', {value: city, text: city}));
                });
            },
            error: function () {
                console.log('Error fetching regions with cities.');
            }
        });
    })


});

function checkPrefectureSelection() {
    var selectedPrefecture = $('.prefecture-select').val();
    if (selectedPrefecture) {
        fetchCitiesForPrefecture(selectedPrefecture);
    }
}

function fetchCitiesForPrefecture(prefecture) {
    var citySelect = $('.city-select');
    var cityVal = $('#hid_city').val();

    // Fetch the JSON data using AJAX
    $.ajax({
        url: '/prefectures_with_cities.json',
        method: 'GET',
        dataType: 'json',
        success: function (regionsWithCities) {
            var cities = regionsWithCities[prefecture] || [];

            // Clear existing city options and add the new ones based on the cities array
            citySelect.empty();
            citySelect.append($('<option>', {value: '', text: '市町村を選択'}));
            $.each(cities, function (index, city) {
                if (cityVal != undefined && cityVal == city) {
                    citySelect.append($('<option>', {value: city, text: city, selected: "selected"}));
                } else {
                    citySelect.append($('<option>', {value: city, text: city}));
                }
            });
        },
        error: function () {
            console.log('Error fetching regions with cities.');
        }
    });
}

$('.prefecture-select').on('change', function () {
    var selectedRegion = $(this).val();
    fetchCitiesForPrefecture(selectedRegion);
});

document.addEventListener("DOMContentLoaded", function () {
    // 編集ボタンがクリックされた時の処理
    document.querySelectorAll('.edit-answer-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            let answerId = e.target.getAttribute('data-answer-id');
            document.getElementById(`answer-text-${answerId}`).style.display = 'none';
            document.getElementById(`answer-edit-${answerId}`).style.display = 'block';
        });
    });

    // キャンセルボタンがクリックされた時の処理
    document.querySelectorAll('.cancel-edit-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            let answerId = e.target.getAttribute('data-answer-id');
            document.getElementById(`answer-edit-${answerId}`).style.display = 'none';
            document.getElementById(`answer-text-${answerId}`).style.display = 'block';
        });
    });
});
$(document).ready(function () {
    $('.thumbnail').click(function () {
        $('.thumbnail').removeClass('thumbnail-selected');
        $(this).addClass('thumbnail-selected');
    });
});

$(document).on('turbolinks:load', function () {
    $('.tabs-community li:first-child').each(function () {
        $(this).addClass('tab-active');
    });
    $('.tabs-stage div:first-child').each(function () {
        $(this).show();
    });

    $('.tabs-nav a').on('click', function (event) {
        event.preventDefault();
        $(this).parent().parent().find('li').removeClass('tab-active');
        $(this).parent().addClass('tab-active');
        $(this).parent().parent().parent().find('.tabs-stage .tabs-stage-element').hide();
        let hrefValue = $(this).attr('href');
        if (hrefValue.startsWith("#")) {
          $($(this).attr('href')).show();
        } else {
          window.location.href = $(this).attr('href')
        }

    });
});
$(document).ready(function () {
    $('.thumbnail').click(function () {
        $('.thumbnail').removeClass('thumbnail-selected');
        $(this).addClass('thumbnail-selected');
    });
});

$(document).ready(function () {
    let selectedRegion = $('#pet-prefecture-select').val();
    let citySelect = $('#pet-city-select');
    let cityVal = citySelect.data("city");
    $.ajax({
        url: '/prefectures_with_cities.json',
        method: 'GET',
        dataType: 'json',
        success: function (regionsWithCities) {
            let cities = regionsWithCities[selectedRegion] || [];

            citySelect.empty();
            citySelect.append($('<option>', { value: '', text: '市町村を選択' }));

            let found = false;

            $.each(cities, function (index, city) {
                let option = $('<option>', { value: city, text: city });

                if (cityVal !== undefined && cityVal === city) {
                    option.prop('selected', true);
                    found = true;
                }
                
                citySelect.append(option);
            });
            if (cityVal !== undefined && !found) {
                citySelect.append($('<option>', { value: cityVal, text: cityVal, selected: "selected" }));
            }
            let url_string = window.location.href;
            let url = new URL(url_string);
            let city = url.searchParams.get("city");
            $('.city-select').val(city);
        },
        error: function () {
            console.log('Error fetching regions with cities.');
        }
    });
    $(".btn-reason").click(function () {
        var checked = false;
        console.log(checked);
        $('.form-check-input').each(function () {
            if ($(this).is(':checked')) {
                checked = true;
                return false;
            }
        });

        if (!checked) {
            alert("少なくとも1つの理由を選択してください。");
            return;
        }

        $(".new-reason").addClass("d-none");
        $(".reason-confirm").removeClass("d-none");
    });
});

$(document).ready(function () {
    let passwordField1 = document.getElementById('password_field1');
    let passwordField2 = document.getElementById('password_field2');
    if (passwordField1 && passwordField2) {
        if (window.innerWidth < 480) {
            passwordField1.removeAttribute('placeholder');
            passwordField2.removeAttribute('placeholder');
        } else {
            passwordField1.setAttribute('placeholder', '半角英数字6文字以上');
            passwordField2.setAttribute('placeholder', '半角英数字6文字以上');
        }
    }
    $("#year-select, #month-select, #day-select").change(function () {
        $("#unknown-radio").prop("checked", false);
    });
});
